import { Headphones, Wrench, UserRound, PackageCheck } from "lucide-react";

export const SUPPORT_TEAMS = [
  {
    slug: "customer-service",
    icon: Headphones,
    title: "Customer Service",
    short: "From deposit questions to chargeback help, our team keeps your transactions smooth.",
    lines: ["Customer", "Service"],
    sub: "Questions about deposits, statements or a disputed charge? Our customer service team gets you clear answers, fast.",
    img: "/img/support-agent.jpg",
    help: [
      ["Deposits & funding", "Track when your money lands and get help if a deposit looks off."],
      ["Statements explained", "We walk you through every line of your statement in plain English."],
      ["Chargebacks & disputes", "Guidance on responding to disputes and the documents you need."],
      ["Account changes", "Update bank details, business info, locations or owners."],
      ["Refunds & voids", "Help processing refunds and correcting transactions."],
      ["Fraud concerns", "Flag suspicious activity and get guidance on next steps."],
    ],
    faqs: [
      ["How do I reach customer service?", "Call us, email us, or book a call at a time that suits you. Your dedicated account manager can also loop the team in."],
      ["Can you help me understand my current processor's statement?", "Yes. Send it over and we'll explain what you're paying today and how we can eliminate transaction fees."],
      ["What should I do if I get a chargeback?", "Contact us as soon as you receive it. We'll explain the reason code and help you gather what's needed to respond."],
    ],
  },
  {
    slug: "tech-support",
    icon: Wrench,
    title: "Tech Support",
    short: "Card readers, terminals and software, set up and fixed so your systems run without a hitch.",
    lines: ["Tech", "Support"],
    sub: "From card readers to POS software, our tech support team sets things up right and gets you back up and running when something goes wrong.",
    img: "/img/tap.jpg",
    help: [
      ["Terminal setup", "Your equipment configured and tested before you take your first payment."],
      ["Troubleshooting", "Connection errors, declined reads or frozen screens, diagnosed and fixed."],
      ["POS & software", "Help configuring menus, items, taxes, tips and receipts."],
      ["Online payments", "Getting your website checkout or payment links working properly."],
      ["Software updates", "Keeping your devices current and secure."],
      ["Replacements", "If a device fails, we help get a working one in your hands."],
    ],
    faqs: [
      ["My terminal isn't connecting. What should I do?", "Restart the device and check its internet or Wi-Fi connection. If it still won't connect, call us and we'll walk you through it."],
      ["Will you set up my new equipment?", "Yes. Our tech support team helps configure your equipment so it's ready to go on day one."],
      ["Can you help with my online checkout?", "Yes. We help you get online payments working on your website and with payment links."],
    ],
  },
  {
    slug: "account-manager",
    icon: UserRound,
    title: "Dedicated Account Manager",
    short: "One person who knows your business and is your direct line for anything you need.",
    lines: ["Dedicated", "Account Manager"],
    sub: "No call centers and no starting over. You get one person who knows your business and is your direct line for anything you need.",
    img: "/img/handshake.jpg",
    help: [
      ["Onboarding", "Guides you from application to your first payment, step by step."],
      ["Eliminating fees", "Reviews your setup and finds the best way to eliminate transaction fees."],
      ["Equipment fit", "Recommends the right hardware for how your business takes payments."],
      ["Account reviews", "Regular check-ins to make sure your setup still fits as you grow."],
      ["Escalations", "Owns your issue across our teams until it's resolved."],
      ["Growth", "New locations, online sales or new products, planned with you."],
    ],
    faqs: [
      ["Will I always talk to the same person?", "Yes. Your dedicated account manager is your main point of contact for your account."],
      ["What does my account manager cost?", "Nothing. A dedicated account manager comes with every account."],
      ["Can my account manager help me switch from my current processor?", "Yes. They'll review your current statement and handle the switch with you."],
    ],
  },
  {
    slug: "equipment",
    icon: PackageCheck,
    title: "Equipment & Setup",
    short: "Free equipment for qualifying merchants, delivered, configured and ready to go.",
    lines: ["Equipment", "& Setup"],
    sub: "Modern terminals and POS systems, free for qualifying merchants, configured by our team so you can start taking payments right away.",
    img: "/img/terminal-blue.jpg",
    help: [
      ["Free equipment", "Qualifying merchants get modern hardware at no cost."],
      ["Countertop terminals", "Chip, swipe and tap at the counter."],
      ["Mobile & tap to pay", "Take payments wherever your business goes."],
      ["Smart POS systems", "Orders, inventory and payments in one place."],
      ["Configured for you", "Set up and tested before it arrives at your door."],
      ["Ongoing help", "Tech support whenever your equipment needs attention."],
    ],
    faqs: [
      ["Is the equipment really free?", "Yes, for qualifying merchants. Your account manager will confirm what you qualify for."],
      ["How do I know which equipment I need?", "Tell us how you take payments and your account manager will recommend the right fit."],
      ["Can I keep using my current equipment?", "In many cases, yes. We'll check whether your existing hardware is compatible."],
    ],
  },
];
